import { Message, Modal } from 'ant-design-vue'

// --------- Message 全局提示 ----------
/**
 *
 * @param { String } type 消息类型 （info、success、error、warning）
 * @param {*} content 消息内容
 * @param { Function } handle 消息提示后进行的操作，若没有操作，则默认 返回一个0
 * @param { Number } 消息持续的时间（以秒为单位），默认为 2.5s
 */
export function tipMsg (type, content, duration = 2.5, handle = () => 0) {
  // console.log(vm.$message)
  switch (type) {
    default: // 默认为info类型的消息
    case 'info':
      Message.info(content, duration).then(handle())
      break
    case 'success':
      Message.success(content, duration).then(handle())
      break
    case 'error':
      Message.error(content, duration).then(handle())
      break
    case 'warning':
      Message.warning(content, duration).then(handle())
      break
  }
}

// --------- Modal 对话框 ----------
/**
 *
 * @param {String} type 消息类型 （info、success、error、warning）
 * @param {String} title 提示标题信息
 * @param {Function} handle 触发事件
 */
export function modalTip (type = 'confirm', title, handle, content = '') {
  switch (type) {
    default: // 默认为confirm提示
    case 'confirm':
      Modal.confirm({
        title: title,
        content: content,
        onOk () {
          handle()
        },
        onCancel () {
          tipMsg('info', `${window.$globalHub.$t('msg.canceled')}`, 1.5)
        }
      })
      break
  }
}
